import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { getCookie } from '@client/services/cookies'

import { createContact } from '@store/ducks/simulate'

import useUtm from '@hooks/useUtm'
import useContact from '@hooks/useContact'
import useDataLayer from '@hooks/useDataLayer'
import useReCaptcha from '@hooks/useReCaptcha'
import useRouteBuilder from '@hooks/useRouteBuilder'

import * as Sections from './sections'

export default function Home() {
  const simulate = useSelector(state => state.simulate)

  const [loading, setLoading] = useState(false)

  const { applyUtm } = useUtm()
  const { contact } = useContact()
  const { setRecaptcha } = useReCaptcha()
  const { events, values } = useDataLayer()
  const { buildRoute } = useRouteBuilder()

  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    if (contact.id) {
      applyUtm(contact.id)
    }
  }, [contact.id])

  if (simulate && !simulate.recaptchaToken) {
    setRecaptcha()
  }

  if (!simulate) {
    setRecaptcha()
  }

  async function handleContactSubmit(contactData) {
    const hubspotutk = getCookie('hubspotutk')

    const data = {
      ...simulate,
      ...contactData,
      country: 'United States',
      token: hubspotutk,
      funnelStage: 'company_info',
    }

    try {
      setLoading(true)

      await dispatch(createContact(data))

      events.simulatorInteraction(values.MAIN_BUTTON)

      setLoading(false)

      history.push(buildRoute('simulate/company-info'))
    } catch (error) {
      if (error.response.status === 409) {
        history.push(buildRoute('thank-you/already-eligible'))
      }
    }
  }
  return (
    <>
      <Sections.Header onSubmit={handleContactSubmit} onLoading={loading} />
      <Sections.Companies />
      <Sections.CompanyPlans />
      <Sections.HowItWorksCompanies />
      <Sections.Benefits />
      <Sections.FeaturedPartners />
      <Sections.HowItWorksEmployees />
      <Sections.GymSearch />
      <Sections.InformationGuide />
      <Sections.FrequentQuestions />
      <Sections.Footer />
    </>
  )
}
